import * as React from 'react';
import type { ConfirmLabels } from '../../organisms/confirm-form';
// import { ConfirmForm } from '../../organisms/confirm-form';
import type { SignupLabels } from '../../organisms/signup-form';
import { SignupForm } from '../../organisms/signup-form';
import { SignupStepEnum, useSignup } from './useSignup';
import type { BrandLogo } from '@components/molecules/brand-header';

type Props = {
	labels: {
		signup: SignupLabels;
		confirm: ConfirmLabels;
	};
	logo?: BrandLogo;
	tosLink: string;
	handleNavigateToLink: () => void;
	onSuccess: (data: any) => void;
	onSSOSuccess: () => void | Promise<void>;
};

export const Signup: React.FC<Props> = ({ labels, logo, tosLink, handleNavigateToLink, onSuccess, onSSOSuccess }) => {
	const { step, handleSignup, handleConfirm, handleResendCode } = useSignup({ onSuccess });

	const CurrentStep = React.useMemo(() => {
		switch (step) {
			case SignupStepEnum.SIGNUP:
				return (
					<SignupForm
						tosLink={tosLink}
						labels={labels.signup}
						logo={logo}
						onSubmit={handleSignup}
						handleNavigateToLink={handleNavigateToLink}
						onSSOSuccess={onSSOSuccess}
					/>
				);
			// case 'confirm':
			// 	return <ConfirmForm labels={labels.confirm} onSubmit={handleConfirm} onRequestNewCode={handleResendCode} />;
			default:
				return null;
		}
	}, [step, logo, handleNavigateToLink, handleSignup, handleResendCode, handleConfirm, onSSOSuccess]);

	return <div className="flex w-full flex-col justify-center">{CurrentStep}</div>;
};
